<template>
  <!-- DUPLICATED from packages/frontend for the studio (intentional — see
       docs/superpowers/specs/2026-06-01-battleplan-authoring-tool-design.md §5).
       Keep rendering in sync with the frontend original when it changes.
       NOTE: App-specific deps removed: injectKeywordAbilities (plugin inject),
       PopOver (complex component), usePrint (print detection). Keywords render
       without clickable ability popups in the editor context. -->
  <span class="keyword">
    <FontAwesomeIcon v-if="isAllianceKeyword" :icon="allianceIconName" class="keyword-icon" />
    <span v-html="formatText(keyword)" />
  </span>
</template>
<script setup lang="ts">
// DUPLICATED from packages/frontend for the studio (intentional — see
// docs/superpowers/specs/2026-06-01-battleplan-authoring-tool-design.md §5).
// Keep rendering in sync with the frontend original when it changes.
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { formatText } from '../utils/formatter.js';
import { allianceIcon } from '../utils/icons.js';

const props = defineProps<{ keyword: string; hasMonsterKeyword?: boolean }>();

const allianceIconName = computed(() => allianceIcon(props.keyword));
const isAllianceKeyword = computed(() => allianceIconName.value !== 'flag');
</script>
<style scoped>
.keyword {
  background: var(--bg-secondary);
  border-radius: 4px;
  padding: 0.1em 0.5em;
  font-weight: 500;
  margin-right: 0.3em;
  margin-bottom: 0.3em;
  white-space: nowrap;
  display: inline-block;
}

.keyword-icon {
  margin-right: 0.3em;
  font-size: 0.9em;
}
</style>
